import { useEffect, useState } from "react";
import BlogRecentSidebar from "./BlogRecentSidebar";
import { BLOG_SIDEBAR_STORAGE_KEY } from "../../utils/blogDisplayUtils";

const BlogPageShell = ({ posts, activeSlug, children, sidebarTitle = "Related Posts" }) => {
  const [showSidebar, setShowSidebar] = useState(true);

  useEffect(() => {
    const stored = window.localStorage.getItem(BLOG_SIDEBAR_STORAGE_KEY);
    if (stored !== null) {
      setShowSidebar(stored === "true");
    }
  }, []);

  const toggleSidebar = () => {
    setShowSidebar((current) => {
      const next = !current;
      window.localStorage.setItem(BLOG_SIDEBAR_STORAGE_KEY, String(next));
      return next;
    });
  };

  const hasPosts = posts.length > 0;

  return (
    <div className="blog-layout-wrap">
      {hasPosts ? (
        <div className="blog-toolbar">
          {!showSidebar ? (
            <button
              type="button"
              className="blog-sidebar-toggle blog-sidebar-toggle--show"
              onClick={toggleSidebar}
            >
              Show related posts
            </button>
          ) : null}
        </div>
      ) : null}

      <div className={`blog-layout${showSidebar && hasPosts ? " with-sidebar" : ""}`}>
        <div className="blog-main">{children}</div>
        {showSidebar && hasPosts ? (
          <BlogRecentSidebar
            posts={posts}
            activeSlug={activeSlug}
            showSidebar={showSidebar}
            onToggle={toggleSidebar}
            title={sidebarTitle}
          />
        ) : null}
      </div>
    </div>
  );
};

export default BlogPageShell;
